"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Play = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var Play = function () { return (react_1.default.createElement("path", { fill: "currentColor", d: "M21.278 11.768v.49c-.002.468-.248.9-.649 1.14l-15.685 9.13c-.946.56-1.437.56-1.857.316l-.439-.246A1.332 1.332 0 012 21.494V2.532c.001-.467.247-.9.648-1.139l.439-.245c.42-.246.91-.246 2.138.473l15.404 9.008c.401.24.647.672.649 1.139z" })); };
exports.Play = Play;
//# sourceMappingURL=play.js.map